import React, { useState } from 'react';
import { Form, Input, Button, Checkbox } from 'antd';
import "./SignUp.css";

function SignUp({setSignUpFlag}) {
  const [loading, setLoading] = useState(false);

  const onFinish = (values) => {
    setLoading(true);
    // You can add your login logic here
    setTimeout(() => {
      setLoading(false);
    }, 2000); // Simulating a delay for demonstration purposes
  };

  return (
    <div className="auth-component">
      <div className="auth-title">
        <p>Create your Account</p>
      </div> 
      <Form
        name="login"
        onFinish={onFinish}
      >
        <Form.Item
          name="username"
          rules={[{ required: true, message: 'Please input your username!' }]}
        >
          <Input placeholder="Username" />
        </Form.Item>

        <Form.Item
          name="password"
          rules={[{ required: true, message: 'Please input your password!' }]}
        >
          <Input.Password placeholder="Password" />
        </Form.Item>

        <Form.Item>
          <Button type="primary" htmlType="submit" loading={loading} style={{ width: '100%' }}>
            Sign Up
          </Button>
        </Form.Item>
        
        <Form.Item>
        <div className="auth-divider">
          <span>.</span>
          <div>OR</div>
          <span>.</span>
        </div>
        </Form.Item>
        <Form.Item>
          <Button onClick={()=>setSignUpFlag(prev=>!prev)} style={{ width: '100%' }}>
            Sign In
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default SignUp;
